import { render, staticRenderFns } from "./MerchantAdd.vue?vue&type=template&id=6b1077c6&scoped=true"
import script from "./MerchantAdd.vue?vue&type=script&lang=js"
export * from "./MerchantAdd.vue?vue&type=script&lang=js"
import style0 from "./MerchantAdd.vue?vue&type=style&index=0&id=6b1077c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1077c6",
  null
  
)

export default component.exports